import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import { TSelectionPages } from "../../../../../../Types";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const MarkAsReadButton = withLiteObserverAndTheme<{
  userID: number;
  conversationID: string;
}>((props) => {
  const { theme, userID, conversationID } = props;
  const { colors, unitX } = theme;
  const { unreadMessagesCounter, conversationType } =
    getKhattabatSharedMessagingStore(conversationID);
  const pageType: TSelectionPages =
    conversationType.get() === "101M" ? "matchResultPage" : "clientPage";

  const shouldShow =
    isPositiveNumber(unreadMessagesCounter.get()) &&
    conversationType.get() !== "101C_COMMENTS" &&
    conversationType.get() !== "101M_COMMENTS";

  return !shouldShow ? null : (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: colors.all.darkOrange,
        borderRadius: 36 * unitX,
        cursor: "pointer"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={async () => {
        getKhattabatStore().setOneOOneMessagesSeen({
          userID,
          pageType
        });
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("MARK_AS_READ")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default MarkAsReadButton;
